export default {"src":"/_next/static/media/new-zealand.72187960.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};